import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../rules/rules.css";
import "./leaderboard.css";
import { selectSessionId, selectOrganizationId } from "../../sessionSlice";
import { getSpaceGamePlayersFromFirebase, rankSpaceGamePlayers } from "../../../functions/spaceGameFirebase";

const REFRESH_INTERVAL_MS = 5000;

function formatSeconds(totalSeconds) {
  const n = Math.max(0, Number(totalSeconds) || 0);
  const m = Math.floor(n / 60);
  const s = Math.floor(n % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

const AdminLeaderboard = () => {
  const navigate = useNavigate();
  const sessionId = useSelector(selectSessionId);
  const organizationId = useSelector(selectOrganizationId);
  const [ranked, setRanked] = useState([]);

  const loadLeaderboard = useCallback(async () => {
    if (!sessionId || !organizationId) return;
    try {
      const players = await getSpaceGamePlayersFromFirebase({ sessionId, organizationId });
      setRanked(rankSpaceGamePlayers(players));
    } catch (e) {
      console.error("Failed to load leaderboard:", e);
    }
  }, [sessionId, organizationId]);

  useEffect(() => {
    loadLeaderboard();
  }, [loadLeaderboard]);

  useEffect(() => {
    const timer = window.setInterval(loadLeaderboard, REFRESH_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [loadLeaderboard]);

  return (
    <div className="rules-page-layout">
      <div className="back-button-holder">
        <button className="back-button" onClick={() => navigate("/admin/lobby")}>
          <i className="fa-solid fa-arrow-left"></i> Back
        </button>
      </div>

      <div className="rules-page-new">
        <div className="admin-tabs-holder">
          <div className="admin-tab-container" style={{ flexBasis: "100%" }}>
            <div className="admin-tab-title">
              <i className="fa-solid fa-trophy"></i> &nbsp; Leaderboard
            </div>
            {ranked.length === 0 ? (
              <p className="lb-empty">No scores yet.</p>
            ) : (
              <div className="lb-table-wrap">
                <table className="lb-table">
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Name</th>
                      <th>Points</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ranked.map((p, idx) => (
                      <tr key={p.userId}>
                        <td>{idx + 1}</td>
                        <td>{p.playerName}</td>
                        <td>{p.totalPoints}</td>
                        <td>{formatSeconds(p.totalTime)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLeaderboard;
